const ActionType = require("action-types/giftcredits");
const SnackbarActions = require("./snackbar");
const WebClient = require("utils/web-client");

const actions = exports;

exports.giftCreditsBegin = () => {
    return {
        type: ActionType.GIFT_CREDITS_BEGIN
    };
};

exports.giftCreditsFailure = () => {
    return {
        type: ActionType.GIFT_CREDITS_FAILURE
    };
};

exports.giftCreditsSuccess = () => {
    return {
        type: ActionType.GIFT_CREDITS_SUCCESS
    };
};

exports.uploadGiftCreditsCSV = (file, callback) => {
    return dispatch => {
        dispatch(actions.giftCreditsBegin());

        const formData = new FormData();
        formData.append("file", file.files[0]);

        WebClient({
            method: "POST",
            url: "/giftcredits",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(({ data }) => {
                dispatch(actions.giftCreditsSuccess());
                dispatch(SnackbarActions.messageSnackbar(data.message));
                callback();
            })
            .catch(err => {
                dispatch(actions.giftCreditsFailure());
                dispatch(SnackbarActions.messageSnackbar(err.message));
                callback(err.response.data.message);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/giftcredits.js